import React, { Component, Fragment } from 'react';
import { ArcaHttpClientInvoice } from '../../../code/ArcaHttpClientInvoice';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaDate } from '../../../code/Types/ArcaDate';
import { StatusBar } from '../StatusBar';
import { InvoiceListPanel } from './InvoiceListPanel';
import { ButtonGroup } from '@material-ui/core';
import { ArcaLink } from '../Fields/ArcaLink';
import { ArcaSecurity } from '../../../code/ArcaSecurity';

export class InvoicePanel extends Component {

    constructor(props) {
        super(props);

        var now = new Date();
        var today = new ArcaDate(now)


        this.state = {
            today,
            invoices: null,
            isError: false,
            statusText: null,
            showAreYouSure: false,
            invoiceId: null
        };
    }

    async componentDidMount() {
        await this.getInvoiceDetails(this.state.today)
    }

    async getInvoiceDetails(date) {
        await ArcaHttpClientInvoice.GetForMonthAsync(
            this.props.ownerId,
            date,
            ((invoices) => {
                this.setState({ invoices })
            }),
            (msg => this.setState({ statusText: msg, isError: false })),
            (msg => this.setState({ statusText: msg, isError: true }))
        )

        this.props.onUpdated();
    }


    async createInvoice(ownerId) {
        await ArcaHttpClientInvoice.CreateInvoiceForUser(this.props.ownerId,
            ((msg) => { this.getInvoiceDetails(this.state.today); this.setState({ statusText: msg, isError: false }) }),
            ((msg) => this.setState({ statusText: msg, isError: true }))
        )
    }


    render() {
        let { invoices, statusText, isError, invoice } = this.state;

        ArcaHttpSystem.Log(`selected invoice: ${invoice}`)

        return (
            <Fragment>
                <h1>Invoicing</h1>
                <StatusBar message={statusText} isError={isError} />
                {ArcaSecurity.IsAdmin
                    ?
                    <div className='centerText'>
                        <ButtonGroup>
                            <ArcaLink width={'175px'} text="Create Invoice(s)" onClick={this.createInvoice.bind(this)} />
                        </ButtonGroup>
                    </div>
                    : null}

                {invoices
                    ? <InvoiceListPanel invoices={invoices} onUpdated={() => this.getInvoiceDetails(this.state.today)} />
                    : null}

            </Fragment>
        );
    }
}